import { Injectable } from '@angular/core';
import { BroadcasterService } from '@draeger-academy/common';
import { Observable } from 'rxjs';

export enum GMBEventType {
    OPEN = 'OPEN',
    CLOSE = 'CLOSE'
}

@Injectable({
    providedIn: 'root'
})
export class GenericModalBroadcasterService {
    constructor(private _broadcasterService: BroadcasterService) {}

    public fire(key: GMBEventType, data?: any) {
        this._broadcasterService.broadcast(`gmb_${key}`, data);
    }

    public onOpen(): Observable<any> {
        return this._broadcasterService.on<any>(`gmb_${GMBEventType.OPEN}`);
    }

    public onClose(): Observable<any> {
        return this._broadcasterService.on<any>(`gmb_${GMBEventType.CLOSE}`);
    }
}
